import React from 'react';
import { useLeadStore } from '@/store/useLeadStore';
import { PROPERTY_TYPES } from '@/utils/constants';

export const Step1ClasseActif: React.FC = () => {
  const { formData, setPropertyType, nextStep } = useLeadStore();

  const handleSelect = (type: 'bureaux' | 'commerce' | 'local-activite' | 'industriel') => {
    setPropertyType(type);
    setTimeout(() => nextStep(), 400);
  };

  return (
    <div className="animate-fade-in">
      <h2 className="text-[28px] font-light tracking-tight mb-2">Classe d'actif</h2>
      <p className="text-sm text-secondary mb-10">
        Quel type de bien souhaitez-vous évaluer ?
      </p>

      <div className="grid grid-cols-2 gap-3 mb-10">
        {PROPERTY_TYPES.map((type) => (
          <div
            key={type.value}
            className={`border border-border py-8 px-5 text-center cursor-pointer transition-all duration-300 text-sm font-medium ${
              formData.propertyType === type.value
                ? 'border-primary bg-[#FAFAFA]'
                : 'hover:border-primary'
            }`}
            onClick={() => handleSelect(type.value)}
          >
            <span className="block text-2xl mb-3">{type.icon}</span>
            {type.title}
          </div>
        ))}
      </div>
    </div>
  );
};
